import classNames from 'classnames'
import React from 'react'

import * as tailwindConfig from '../../tailwind.config'
import { ProgressSpinner } from '../spinner'

type LoaderProps = {
  // ClassName
  className?: string
  // Foreground color
  fgColor?: string
  // Background color
  bgColor?: string
}

/** Loader used to show that an app page is being loaded. */
const Loader = ({ className, fgColor, bgColor }: LoaderProps) => {
  return (
    <div className={classNames('h-6 w-6', className)}>
      <ProgressSpinner
        strokeWidth={4}
        progress={25}
        total={100}
        progressColor={fgColor || tailwindConfig.theme.colors.primary.DEFAULT}
        remainingColor={bgColor || tailwindConfig.theme.colors.primary[700]}
      />
    </div>
  )
}

export default Loader
